import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.search');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-search',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.search/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageSearchComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }
    public keyword: string = '';
    public searchType: string = 'all'; // all, title, artist
    public songs: any[] = [];
    public searched: boolean = false;
    public loading: boolean = false;
    public total: number = 0;
    public page: number = 1;
    public dump: number = 20;
    public songCount: number = 0;
    public catalogCount: number = 0;
    public approvedCount: number = 0;
    public emptyReason: string = '';

    public async ngOnInit() {
        await this.service.init();
    }

    public async search(reset: boolean = true) {
        if (!this.keyword.trim()) return;
        if (this.loading) return;
        if (reset) { this.page = 1; this.songs = []; }
        this.loading = true;
        this.searched = true;
        await this.service.render();

        try {
            let { code, data } = await wiz.call("search", {
                keyword: this.keyword,
                search_type: this.searchType,
                page: this.page,
                dump: this.dump
            });
            if (code === 200) {
                if (reset) {
                    this.songs = data.songs || [];
                } else {
                    this.songs = [...this.songs, ...(data.songs || [])];
                }
                this.total = data.total || 0;
                this.songCount = data.song_count || 0;
                this.catalogCount = data.catalog_count || 0;
                this.approvedCount = data.approved_count || this.songCount;
                this.emptyReason = data.empty_reason || '';
            }
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async setSearchType(type: string) {
        this.searchType = type;
        if (this.keyword.trim()) await this.search(true);
        else await this.service.render();
    }

    public async loadMore() {
        if (this.loading || this.songs.length >= this.total) return;
        this.page++;
        await this.search(false);
    }

    public goSong(id: string) {
        this.service.href('/song/' + id);
    }

    public getEmptyTitle(): string {
        if (this.emptyReason === 'no_catalog' || this.emptyReason === 'no_songs') return '등록된 곡 데이터가 없습니다';
        if (this.emptyReason === 'no_approved') return '승인된 곡이 아직 없습니다';
        return '검색 결과가 없습니다';
    }

    public getEmptyHint(): string {
        if (this.emptyReason === 'no_catalog' || this.emptyReason === 'no_songs') return '관리자가 곡을 등록하면 검색할 수 있습니다.';
        if (this.emptyReason === 'no_approved') return '등록된 곡을 승인하면 검색에 표시됩니다.';
        return '띄어쓰기, 가수명, TJ/KY 번호 또는 초성을 바꿔서 검색해보세요.';
    }

    public goAdminSongs() {
        this.service.href('/admin/songs');
    }

    public showAdminSongAction(): boolean {
        return this.emptyReason === 'no_catalog' || this.emptyReason === 'no_approved' || this.emptyReason === 'no_songs';
    }
}

export default PageSearchComponent;